import {CurrentUser} from '../../types/interfaces';

export class FetchCurrentUser {
  static readonly type = '[CurrentUser] Fetch All';

  constructor(public payload: CurrentUser) {
  }
}
